module.exports = __webpack_public_path__ + "img/riskControl.1fafda78.png";